import iban from 'iban'

export const isValidIban = (value: string): boolean => {
  if (!value) return false
  return iban.isValid(value.replace(/\s/g, ''))
}

export const extractBankCode = (ibanValue: string): { country: string; code: string } | null => {
  if (!ibanValue) return null

  const cleaned = ibanValue.replace(/\s/g, '').toUpperCase()
  const country = cleaned.substring(0, 2)

  const positions: Record<string, [number, number]> = {
    FR: [4, 9],
    BE: [4, 7],
    DE: [4, 12],
  }

  const pos = positions[country]
  if (!pos) return null

  return { country, code: cleaned.substring(pos[0], pos[1]) }
}
